const SETTINGS_UPDATE = 'settings/UPDATE';

export {
  SETTINGS_UPDATE
}